import type { ListPageColumn } from '@/components/templates/list-page'
import { Button } from '@/components/ui/button'
import { ConnectionCount, ConnectionName, HealthBadge, LastRun, NextRun } from './ConnectionCells'
import { connectionTypeName, type Connection } from './types'
import type { useConnectionsList } from './useConnectionsList'

export function connectionColumns(
  sortable: ReturnType<typeof useConnectionsList>['sortable'],
  restore?: (row: Connection) => void,
  pending = false,
): ListPageColumn<Connection>[] {
  const columns: ListPageColumn<Connection>[] = [
    {
      id: 'name',
      header: 'Name',
      sort: sortable('name'),
      cell: (row) => <ConnectionName row={row} />,
    },
    {
      id: 'type',
      header: 'Type',
      className: 'whitespace-nowrap text-muted-foreground',
      cell: (row) => connectionTypeName(row.connection_type),
    },
    {
      id: 'health',
      header: 'Health',
      sort: sortable('health'),
      className: 'whitespace-nowrap',
      cell: (row) => <HealthBadge row={row} />,
    },
    {
      id: 'last_run',
      header: 'Last run',
      headerClassName: 'whitespace-nowrap',
      sort: sortable('last_run'),
      cell: (row) => <LastRun row={row} />,
    },
    {
      id: 'next_run',
      header: 'Next run',
      className: 'whitespace-nowrap',
      cell: (row) => <NextRun row={row} />,
    },
    {
      id: 'unmatched',
      header: 'Unmatched',
      className: 'text-right tabular-nums',
      headerClassName: 'text-right',
      cell: (row) => <ConnectionCount row={row} kind="unmatched" />,
    },
    {
      id: 'errors',
      header: 'Errors',
      className: 'text-right tabular-nums',
      headerClassName: 'text-right',
      cell: (row) => <ConnectionCount row={row} kind="error" />,
    },
  ]
  if (restore)
    columns.push({
      id: 'restore',
      header: '',
      className: 'text-right py-0',
      cell: (row) =>
        row.status === 'removed' ? (
          <Button
            variant="outline"
            size="sm"
            disabled={pending}
            onKeyDown={(event) => event.stopPropagation()}
            onClick={(event) => {
              event.stopPropagation()
              restore(row)
            }}
          >
            Restore
          </Button>
        ) : null,
    })
  return columns
}
